import { render, staticRenderFns } from "./PriceResult.vue?vue&type=template&id=539c194d&scoped=true&"
import script from "./PriceResult.vue?vue&type=script&lang=js&"
export * from "./PriceResult.vue?vue&type=script&lang=js&"
import style0 from "./PriceResult.vue?vue&type=style&index=0&id=539c194d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539c194d",
  null
  
)

export default component.exports